import { Button } from '@tmov/design-system';
import { Form } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';

const DrawerFooter = ({ submitForm }) => (
  <Form.Item>
    <Button style={{ width: '100%' }} type="submit" onClick={submitForm}>
      Aplicar filtros
    </Button>
  </Form.Item>
);

DrawerFooter.propTypes = {
  submitForm: PropTypes.func.isRequired,
};

export { DrawerFooter };
